import { useI18n } from "../lib/i18n";

export const Ticker = () => {
  const { t } = useI18n();
  const items = [...t.ticker, ...t.ticker, ...t.ticker, ...t.ticker];

  return (
    <div
      data-testid="ticker"
      className="bg-[#E51E1A] border-y border-black overflow-hidden py-4"
    >
      <div className="flex whitespace-nowrap ticker-track">
        {items.map((it, i) => (
          <div
            key={i}
            className="flex items-center font-headings uppercase text-white text-2xl md:text-3xl px-8 tracking-wider"
          >
            <span className="mr-8 text-black/40">/</span>
            {it}
          </div>
        ))}
      </div>
    </div>
  );
};
